export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8423.3ae10370.jpg";